// Functions
import VerifyToken from "../../config/verifyToken";
import useReportAccess from "../../config/useReportAccess";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import AdvancedAnalyticsView from "../../components/advancedAnalytics";

const AdvancedAnalytics = () => {
  useReportAccess("ADVANCED_ANALYTICS");

  return (
    <>
      {VerifyToken()}
      <Header />
      <Main>
        <StickyLogo />
        <AdvancedAnalyticsView />
      </Main>
    </>
  );
};

export default AdvancedAnalytics;
